import { ResourceManager } from "@/components/ResourceManager";
import { Mail } from "lucide-react";

const fields = [
  { name: "name", label: "Name", type: "text" },
  { name: "email", label: "Email", type: "text" },
  { name: "mobile", label: "Mobile", type: "text" },
  { name: "type", label: "Type", type: "text" },
  { name: "subject", label: "Subject", type: "text" },
  { name: "message", label: "Message", type: "textarea", table: false },
];

export default function EnquiriesAdmin() {
  return <ResourceManager title="Enquiries & Messages" eyebrow="Community" endpoint="enquiries" fields={fields} readOnly icon={Mail} />;
}
